import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../util/assets';
import Button from '../Button';
import Reward from './components/Reward';
import { ACHIEVEMENT_ACTIONS_LINKED_ACHIEVEMENTS } from '../../../constants/achievements';
import PendingAchievement from './components/PendingAchievement';
import CheckboxIcon from '../../icons/CheckboxIcon';
import { getSortedPendingAchievementsLevels } from '../../../util/achievements';

const propTypes = {
  achievementLevels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      achievement: PropTypes.shape({
        id: PropTypes.string,
        action: PropTypes.string,
      }),
    }),
  ),
  pendingAchievementLevels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      achievement: PropTypes.shape({
        id: PropTypes.string,
        action: PropTypes.string,
      }),
    }),
  ),
  onClose: PropTypes.func,
};

const AchievementUnlocked = ({
  achievementLevels = [],
  pendingAchievementLevels = [],
  onClose,
}) => {
  const [achievementLevelIndex, setAchievementLevelIndex] = useState(0);
  const achievementLevel = achievementLevels[achievementLevelIndex];

  if (!achievementLevel) {
    return null;
  }

  const linkedPendingAchievementsLevels = getSortedPendingAchievementsLevels(
    ACHIEVEMENT_ACTIONS_LINKED_ACHIEVEMENTS[achievementLevel.achievement.action]
      .map(linkedAchievementAction =>
        pendingAchievementLevels.find(
          pendingAchievementLevel =>
            pendingAchievementLevel.achievement.action ===
            linkedAchievementAction,
        ),
      )
      .filter(Boolean),
  );

  return (
    <div className="achievement-unlocked-wrapper">
      <img
        src={getAsset('/confetti-transparent.png')}
        alt="Confetti"
        className="achievement-unlocked-confetti"
      />
      <div className="d-flex mb-2">
        <img
          src={getAsset('/trophy.svg')}
          alt="Trophy"
          className="achievement-unlocked-trophy"
          width="100px"
        />
      </div>
      <h2 className="mt-0 text-center text-white">
        Congrats, you&rsquo;ve earned free stuff!
      </h2>
      <div className="d-flex mt-4">
        <CheckboxIcon
          color="#0d84fe"
          secondaryColor="#fff"
          className="mr-2"
          size={25}
        />
        <div>
          <h3 className="text-white mb-0">Milestone</h3>
          <p className="mb-0">{achievementLevel.name}</p>
          <p className="achievement-unlocked-reward-label">Reward</p>
          <div className="row">
            {achievementLevel.rewards.map(reward => (
              <div className="col-4">
                <Reward reward={reward} key={reward.id} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {linkedPendingAchievementsLevels.length > 0 && (
        <div className="mt-2 mb-5 mb-sm-0">
          <p className="reward-label mb-0">Earn more free stuff!</p>
          {linkedPendingAchievementsLevels.map(pendingAchievementLevel => (
            <PendingAchievement
              achievementLevel={pendingAchievementLevel}
              className="text-white mb-2"
            />
          ))}
        </div>
      )}

      {achievementLevelIndex !== achievementLevels.length - 1 ? (
        <Button
          btnStyle="link"
          btnSize="xl"
          className="achievement-dismiss"
          onClick={() => setAchievementLevelIndex(achievementLevelIndex + 1)}
        >
          See next unlocked achievement
        </Button>
      ) : (
        <Button
          btnStyle="link"
          btnSize="xl"
          className="achievement-dismiss"
          onClick={onClose}
        >
          Got it!
        </Button>
      )}
    </div>
  );
};

export { AchievementUnlocked as AchievementUnlockedComponent };

AchievementUnlocked.propTypes = propTypes;

export default AchievementUnlocked;
